/*
 * @Author: hfxie
 * @Date: 2022-08-17 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-08 14:53:39
 * @Description: 常量:交互自定义事件接口·被调用的方法名
 */

const DEMO = "gtRefreshIniControlGanttData"; // 示例进来的常量方法名

const DATA_LOADING = "dataLoading"; // 初始化·主动发起数据加载
const INIT_APP = "init"; // 初始化·刷新数据
const SET_LIST = "updateList"; // 全量·设置行集合
const ADD_ROW = "addRow"; // 局部更新·增加行
const DELETE_ROW = "deleteRow"; // 局部更新·删除行
const UPDATE_ROW = "updateRow"; // 局部更新·修改行
const UPDATE_ROWS = "updateRows"; // 通用局部更新
const UPDATE_DETAILID = "updateDetailId"; // 切换选中展示行


const InConst = {
  DEMO,
  
  DATA_LOADING,
  INIT_APP,
  SET_LIST,
  ADD_ROW,
  DELETE_ROW,
  UPDATE_ROW,
  UPDATE_ROWS,
  UPDATE_DETAILID,

};

export default InConst;
